export default __webpack_public_path__ + "static/media/kitchen4-afterD-768w.b1b28478.webp";